import { FC, useState } from 'react';
import { get } from 'lodash';
import { Button } from '@packages/utils';
import { PersonRemoveOutline } from 'assets/icon/icon';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { Modal } from 'components/Base/Modal';
import ConfirmModalBody from 'components/Shared/ConfirmModalBody';
import { TRtkErrorType } from 'data/types/generic.types';
import { useDeleteWaitListRegistrantMutation } from 'redux/apiSlice/registrants.slice';
import { TDeleteActionProps } from './DeleteAction.types';

const DeleteAction: FC<TDeleteActionProps> = ({ registrantId, workshopId }) => {
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
  const [deleteWaitListRegistrant, { isLoading }] =
    useDeleteWaitListRegistrantMutation();
  const { showToastNotification } = useShowToastNotification();

  const handleClose = () => setOpenConfirmModal(false);

  const handleSubmit = async () => {
    try {
      if (!workshopId) return;
      await deleteWaitListRegistrant({ registrantId, workshopId }).unwrap();
      showToastNotification({
        message: 'Registrant has been successfully removed from the Waitlist',
        type: ENotificationType.SUCCESS,
      });
      handleClose();
    } catch (e) {
      const message =
        get(e as TRtkErrorType, 'data.message') ||
        'Failed to remove registrant from the Waitlist';
      showToastNotification({
        message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <>
      <Button
        icon={<PersonRemoveOutline size={20} fill="#656565" />}
        onClick={() => setOpenConfirmModal(true)}
        tooltip="Remove from Waitlist"
        color="primary"
        shape="circle"
        size="middle"
      />

      {openConfirmModal && (
        <Modal
          title="Remove from Waitlist"
          open={openConfirmModal}
          onCancel={handleClose}
          onOk={handleSubmit}
          okText="Remove"
          cancelText="Cancel"
          confirmLoading={isLoading}
        >
          <ConfirmModalBody description="Are you sure you want to remove this registrant from the Waitlist?" />
        </Modal>
      )}
    </>
  );
};

export default DeleteAction;
